import { useIntl } from 'react-intl'

import { Typography, TypographyProps } from '@mui/material'
import { TextLink } from 'components/shared'

interface AdditionalServiceUrlLinkProps extends TypographyProps {
  url: string
}
export const AdditionalServiceUrlLink = ({ url, ...otherProps }: AdditionalServiceUrlLinkProps) => {
  const { formatMessage } = useIntl()

  return (
    <Typography variant="inherit" {...otherProps}>
      {formatMessage(
        { id: 'button.click_here_to_learn_more' },
        {
          link: (
            <TextLink href={url} id="rodo-link">
              {formatMessage({ id: 'button.here', defaultMessage: 'here' })}
            </TextLink>
          ),
        },
      )}
    </Typography>
  )
}
